import Consumer from "../../models/Consumer";
import Fuse from "../../models/Fuse";
import { SequenceStep, enumActions } from "../Guide";
import { ToDoItem } from "../ToDoItem";
import guideSequence_addConsumerButton from "./guideSequence_addConsumerButton";
import guideSequence_addFuse from "./guideSequence_addFuse";

// ContextMenuLables.addFloors
/////////////////////////////////////////////////////////
/////////// noch in bearbeitung hinten angestellt
/////////////////////////////////////////////////
function sequence(type: string, lastToDoItem?: ToDoItem): Array<SequenceStep> {
  let firstFuse: Fuse | undefined = state.allFuses()[0];
  let firstConsumer: Consumer | undefined = state.allConsumers()[0];
  return [
    {
      action: enumActions.call,
      subSequence: () => {
        let res = new Array<SequenceStep>();
        if (!firstFuse) {
          res.push(...guideSequence_addFuse(""));
        }
        if (!firstConsumer) {
          res.push(...guideSequence_addConsumerButton("Consumer")); // no itx
        }
        return res;
      },
    },
    {
      action: enumActions.function,
      func: async (): Promise<void> => {
        firstFuse = state.allFuses()[0];
        firstConsumer = state.allConsumers()[0];
        state.selectionManager.selectedObject = firstFuse;
      },
    },
    {
      action: enumActions.wait,
    },
    {
      action: enumActions.focus,
      id: () => {
        return `tv-${firstFuse?.id}`;
      },
    },
    {
      action: enumActions.click,
      id: () => {
        return [`tv-${firstFuse?.id}`, `homePane_openFuseSettings`];
      },
    },
    {
      action: enumActions.wait,
    },
    {
      action: enumActions.click,
      id: () => {
        return "CreateConnectionFuseButton"; // no itx
      },
    },
  ];
}

export default sequence;
